/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { Dialog } from 'primereact/dialog';
import { InputText  } from 'primereact/inputtext';

class ModalInputText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      placeHolder: '',
      maxLength: null,
      minLength: null,
    }
  }

  componentDidMount() {
    const { target } = this.props
    const getPlaceHolder = target.placeholder
    const getMinLength = target.minLength < 0 ? null: target.minLength
    const getMaxLength = target.maxLength  < 0 ? null: target.maxLength 


    this.setState({
      placeHolder: getPlaceHolder,
      minLength: getMinLength,
      maxLength: getMaxLength,
      loadingPage: false
    })
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { onContinueAction, onHidden } = this.props
    const { placeHolder, minLength,maxLength } = this.state

    onContinueAction({placeHolder, minLength: minLength || null, maxLength: maxLength || null})
    return onHidden()
  }
  
  render () {
    const { t, title, onHidden, label, btnOkLabel, isAddRemoveElements } = this.props
    const { placeHolder, minLength, maxLength, loadingPage } = this.state

    const children = loadingPage ? '' : (
      <form className="p-mt-2 p-fluid" onSubmit={this.onSubmit}>
        <div className="col-12">
          <label className="">{label || t('Configura el texto que tendra de placeholder el campo seleccionado')}</label>
          <div className="p-inputgroup">
              <span className="p-inputgroup-addon">≈</span>
              <InputText
                value={placeHolder}
                onChange={(e) =>
                  this.setState({ placeHolder: e.target.value })
                }
              />
          </div>
        </div>
        <div className="col-6">
            <label className="">{label || t('Longitud Minima')}</label>
            <div className="p-inputgroup">
                <span className="p-inputgroup-addon">-</span>
                <InputText 
                  value={minLength}
                  keyfilter="int"
                  onChange={(e) =>
                    this.setState({ minLength: e.target.value })
                  }
                  disabled={!isAddRemoveElements}
                />
            </div>
        </div>
        <div className="col-6">
            <label className="">{label || t('Longitud Máxima')}</label>
            <div className="p-inputgroup">
                <span className="p-inputgroup-addon">+</span>
                <InputText 
                  value={maxLength}
                  keyfilter="int"
                  onChange={(e) =>
                    this.setState({ maxLength: e.target.value })
                  }
                  disabled={!isAddRemoveElements}
                />
            </div>
        </div>

        <div className="p-dialog-footer custom">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button> 
            <button className="p-button p-component" type="submit">
              <span className="p-button-label p-c">{btnOkLabel || 'Continuar'}</span>
            </button>
          </div>
        </div>
      </form>
    )
    if (loadingPage) return true;

    return (
      <Dialog
        header={title || t('Input tipo texto')}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '30vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps))(ModalInputText)